import * as THREE from "three";

export default function theme(scene){
    const themeBtn = document.getElementById('theme-toggle');

    if (localStorage.getItem('theme') === 'dark') {
        document.body.classList.add('dark-theme');
        scene.background = new THREE.Color(0x1a1a1a);
    }

    themeBtn.addEventListener('click', () => {
        document.body.classList.toggle('dark-theme');

        const isDark = document.body.classList.contains('dark-theme');
        localStorage.setItem('theme', isDark ? 'dark' : 'light');

        if (isDark) {
            scene.background = new THREE.Color(0x1a1a1a);
        } else {
            scene.background = new THREE.Color(0xffffff);
        }
    });
}

